/**
 * Commercial / Music / Promotion video & Director: EN+KO 리치 텍스트(Quill).
 * 공지·아티스트와 동일 패턴: 제출 시 hidden에 HTML 동기화, 이미지는 admin.uploads.image.
 */
import { Logger } from "../../utils/Logger";
import { QuillEditor, stripBase64Images } from "../../components/QuillEditor";

function noop(c: string, a: string): void {
    Logger.debug(`${c}.${a} (no-op)`);
}

type DualCfg = {
    formId: string;
    prefix: string;
    fieldEn: string;
    fieldKo: string;
};

function initDualRichText(cfg: DualCfg): void {
    const form = document.getElementById(cfg.formId) as HTMLFormElement | null;
    if (!form) return;

    const editorEn = document.getElementById(`${cfg.prefix}-richtext-en`);
    const editorKo = document.getElementById(`${cfg.prefix}-richtext-ko`);
    const inputEn = document.getElementById(`${cfg.prefix}-input-en`) as HTMLInputElement | null;
    const inputKo = document.getElementById(`${cfg.prefix}-input-ko`) as HTMLInputElement | null;

    if (!editorEn || !editorKo || !inputEn || !inputKo) return;

    const uploadImageUrl = form.dataset.uploadImageUrl ?? "";
    const csrf =
        (form.querySelector('input[name="_token"]') as HTMLInputElement | null)?.value ?? "";

    let initialEn = "";
    let initialKo = "";
    const initEl = document.getElementById(`${cfg.prefix}-richtext-initial`);
    if (initEl?.textContent) {
        try {
            const j = JSON.parse(initEl.textContent) as { en?: string; ko?: string };
            initialEn = j.en ?? "";
            initialKo = j.ko ?? "";
        } catch {
            /* ignore */
        }
    }

    const uploadConfig =
        uploadImageUrl && csrf
            ? {
                  uploadUrl: uploadImageUrl,
                  csrf,
                  fileKey: "image" as const,
                  getUrl: (json: Record<string, unknown>) =>
                      (json?.data as Record<string, unknown>)?.url as string | undefined,
              }
            : undefined;

    const placeholderEn = "Content (EN). Images: toolbar image button.";
    const placeholderKo = "내용 (KO). 이미지는 툴바 이미지 버튼으로 넣을 수 있습니다.";

    const quillEn = new QuillEditor(editorEn, {
        placeholder: placeholderEn,
        initialHtml: initialEn,
        upload: uploadConfig,
    });
    quillEn.init();

    const quillKo = new QuillEditor(editorKo, {
        placeholder: placeholderKo,
        initialHtml: initialKo,
        upload: uploadConfig,
    });
    quillKo.init();

    form.addEventListener(
        "submit",
        () => {
            inputEn.value = stripBase64Images(quillEn.getHtml());
            inputKo.value = stripBase64Images(quillKo.getHtml());
        },
        true
    );
}

const TAG_CV = "AdminCommercialVideoController";
export const AdminCommercialVideoController = {
    index(): void {
        noop(TAG_CV, "index");
    },
    create(): void {
        initDualRichText({
            formId: "commercial-video-form",
            prefix: "cv",
            fieldEn: "content_en",
            fieldKo: "content_ko",
        });
    },
    store(): void {
        noop(TAG_CV, "store");
    },
    edit(): void {
        initDualRichText({
            formId: "commercial-video-form",
            prefix: "cv",
            fieldEn: "content_en",
            fieldKo: "content_ko",
        });
    },
    update(): void {
        noop(TAG_CV, "update");
    },
    destroy(): void {
        noop(TAG_CV, "destroy");
    },
};

const TAG_MV = "AdminMusicVideoController";
export const AdminMusicVideoController = {
    index(): void {
        noop(TAG_MV, "index");
    },
    create(): void {
        initDualRichText({
            formId: "music-video-form",
            prefix: "mv",
            fieldEn: "content_en",
            fieldKo: "content_ko",
        });
    },
    store(): void {
        noop(TAG_MV, "store");
    },
    edit(): void {
        initDualRichText({
            formId: "music-video-form",
            prefix: "mv",
            fieldEn: "content_en",
            fieldKo: "content_ko",
        });
    },
    update(): void {
        noop(TAG_MV, "update");
    },
    destroy(): void {
        noop(TAG_MV, "destroy");
    },
};

const TAG_PV = "AdminPromotionVideoController";
export const AdminPromotionVideoController = {
    index(): void {
        noop(TAG_PV, "index");
    },
    create(): void {
        initDualRichText({
            formId: "promotion-video-form",
            prefix: "pv",
            fieldEn: "content_en",
            fieldKo: "content_ko",
        });
    },
    store(): void {
        noop(TAG_PV, "store");
    },
    edit(): void {
        initDualRichText({
            formId: "promotion-video-form",
            prefix: "pv",
            fieldEn: "content_en",
            fieldKo: "content_ko",
        });
    },
    update(): void {
        noop(TAG_PV, "update");
    },
    destroy(): void {
        noop(TAG_PV, "destroy");
    },
};

const TAG_DR = "AdminDirectorController";
export const AdminDirectorController = {
    index(): void {
        noop(TAG_DR, "index");
    },
    create(): void {
        initDualRichText({
            formId: "admin-director-form",
            prefix: "dir",
            fieldEn: "description_en",
            fieldKo: "description_ko",
        });
    },
    store(): void {
        noop(TAG_DR, "store");
    },
    edit(): void {
        initDualRichText({
            formId: "admin-director-form",
            prefix: "dir",
            fieldEn: "description_en",
            fieldKo: "description_ko",
        });
    },
    update(): void {
        noop(TAG_DR, "update");
    },
    destroy(): void {
        noop(TAG_DR, "destroy");
    },
};
